export const DEFAULT_DATA_SCHEMA_FIELD_TYPE = 'string';
